// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    ADD_CLAIM_TO_TCSM_AUDIT: 'ADD_CLAIM_TO_TCSM_AUDIT',
    CALCULATE_TCSM_PERCENTAGE_DEBIT_VALUE: 'CALCULATE_TCSM_PERCENTAGE_DEBIT_VALUE',
    CLOSE_TCSM_AMOUNT_OF_USE_MODAL: 'CLOSE_TCSM_AMOUNT_OF_USE_MODAL',
    CLOSE_TCSM_LABOR_RATE_MODAL: 'CLOSE_TCSM_LABOR_RATE_MODAL',
    CLOSE_TCSM_MACHINE_STATUS_MODAL: 'CLOSE_TCSM_MACHINE_STATUS_MODAL',
    CLOSE_TCSM_PIP_CODE_REQUEST_MODAL: 'CLOSE_TCSM_PIP_CODE_REQUEST_MODAL',
    CLOSE_TCSM_SPA_CLAIM_MODAL: 'CLOSE_TCSM_SPA_CLAIM_MODAL',
    OPEN_TCSM_AMOUNT_OF_USE_MODAL: 'OPEN_TCSM_AMOUNT_OF_USE_MODAL',
    OPEN_TCSM_LABOR_RATE_MODAL: 'OPEN_TCSM_LABOR_RATE_MODAL',
    OPEN_TCSM_MACHINE_STATUS_MODAL: 'OPEN_TCSM_MACHINE_STATUS_MODAL',
    OPEN_TCSM_PIP_CODE_REQUEST_MODAL: 'OPEN_TCSM_PIP_CODE_REQUEST_MODAL',
    OPEN_TCSM_SPA_CLAIM_MODAL: 'OPEN_TCSM_SPA_CLAIM_MODAL',
    REMOVE_CLAIM_FROM_TCSM_AUDIT: 'REMOVE_CLAIM_FROM_TCSM_AUDIT',
    REPLACE_TCSM_PREPARE_AUDIT_CLAIMS: 'REPLACE_TCSM_PREPARE_AUDIT_CLAIMS',
    RESET_TCSM_AUDIT_CLAIM_FACETS: 'RESET_TCSM_AUDIT_CLAIM_FACETS',
    RESET_TCSM_AUDIT_CONFIRMATION_MODAL: 'RESET_TCSM_AUDIT_CONFIRMATION_MODAL',
    RESET_TCSM_CLAIM_DEBIT: 'RESET_TCSM_CLAIM_DEBIT',
    RESET_TCSM_CLOSING_ACCOUNT_SEARCH_FILTERS: 'RESET_TCSM_CLOSING_ACCOUNT_SEARCH_FILTERS',
    RESET_TCSM_DUPLICATE_PIN_PLATE_SEARCH_FILTERS: 'RESET_TCSM_DUPLICATE_PIN_PLATE_SEARCH_FILTERS',
    RESET_TCSM_LABOR_RATE_SEARCH_FILTERS: 'RESET_TCSM_LABOR_RATE_SEARCH_FILTERS',
    RESET_TCSM_MACHINE_STATUS_SEARCH_FILTERS: 'RESET_TCSM_MACHINE_STATUS_SEARCH_FILTERS',
    RESET_TCSM_MACHINE_STATUS_UPDATES: 'RESET_TCSM_MACHINE_STATUS_UPDATES',
    RESET_TCSM_PARTIAL_DEBIT: 'RESET_TCSM_PARTIAL_DEBIT',
    RESET_TCSM_PERCENTAGE_DEBIT: 'RESET_TCSM_PERCENTAGE_DEBIT',
    RESET_TCSM_PIP_CODE_REQUESTS: 'RESET_TCSM_PIP_CODE_REQUESTS',
    RESET_TCSM_PIP_CODE_REQUESTS_SEARCH_FILTERS: 'RESET_TCSM_PIP_CODE_REQUESTS_SEARCH_FILTERS',
    RESET_TCSM_PREPARE_AUDIT_AUDIT: 'RESET_TCSM_PREPARE_AUDIT_AUDIT',
    RESET_TCSM_RECORD_AUDIT: 'RESET_TCSM_RECORD_AUDIT',
    RESET_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM: 'RESET_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM',
    RESET_TCSM_SELECTED_DEALERS: 'RESET_TCSM_SELECTED_DEALERS',
    RESET_TCSM_SPA_CLAIMS_SEARCH_FILTERS: 'RESET_TCSM_SPA_CLAIMS_SEARCH_FILTERS',
    RESET_TCSM_SPA_CLAIM_DETAILS: 'RESET_TCSM_SPA_CLAIM_DETAILS',
    RESET_TCSM_WIP_TCSM_SETTINGS_FACET: 'RESET_TCSM_WIP_TCSM_SETTINGS_FACET',
    SET_TCSM_AUDIT_CONFIRMATION_MODAL: 'SET_TCSM_AUDIT_CONFIRMATION_MODAL',
    TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_AMOUNT: 'TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_AMOUNT',
    TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_PERCENT: 'TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_PERCENT',
    TOGGLE_TCSM_REPORTS_ACCORDION: 'TOGGLE_TCSM_REPORTS_ACCORDION',
    TOGGLE_TCSM_WIP_SPA_LEVELS_LIST: 'TOGGLE_TCSM_WIP_SPA_LEVELS_LIST',
    UPDATE_NEW_TRANSFER_OVERRIDE_DEALER: 'UPDATE_NEW_TRANSFER_OVERRIDE_DEALER',
    UPDATE_OVERRIDE_CLOSE_ACCOUNT: 'UPDATE_OVERRIDE_CLOSE_ACCOUNT',
    UPDATE_TCSM_ACCOUNT_LOOKUP: 'UPDATE_TCSM_ACCOUNT_LOOKUP',
    UPDATE_TCSM_AMOUNT_OF_USE_COMMENTS_TO_DEALER: 'UPDATE_TCSM_AMOUNT_OF_USE_COMMENTS_TO_DEALER',
    UPDATE_TCSM_AMOUNT_OF_USE_INTERNAL_DEERE_COMMENTS: 'UPDATE_TCSM_AMOUNT_OF_USE_INTERNAL_DEERE_COMMENTS',
    UPDATE_TCSM_AMOUNT_OF_USE_ITEM_TO_UPDATE: 'UPDATE_TCSM_AMOUNT_OF_USE_ITEM_TO_UPDATE',
    UPDATE_TCSM_AMOUNT_OF_USE_LENGTH: 'UPDATE_TCSM_AMOUNT_OF_USE_LENGTH',
    UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS: 'UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS',
    UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_FILTER_BY: 'UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_FILTER_BY',
    UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_BY: 'UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_BY',
    UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_DIRECTION: 'UPDATE_TCSM_AMOUNT_OF_USE_REQUESTS_SORT_DIRECTION',
    UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPES: 'UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPES',
    UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_SELECTED: 'UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_SELECTED',
    UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_TOGGLED: 'UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_TOGGLED',
    UPDATE_TCSM_AUDIT_CLAIM_DATE_ISSUED: 'UPDATE_TCSM_AUDIT_CLAIM_DATE_ISSUED',
    UPDATE_TCSM_AUDIT_CLAIM_FILTERED: 'UPDATE_TCSM_AUDIT_CLAIM_FILTERED',
    UPDATE_TCSM_AUDIT_CLAIM_FILTER_BY: 'UPDATE_TCSM_AUDIT_CLAIM_FILTER_BY',
    UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SELECTED: 'UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SELECTED',
    UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SUCCESS: 'UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SUCCESS',
    UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_DOLLARS: 'UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_DOLLARS',
    UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_PERCENT: 'UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_PERCENT',
    UPDATE_TCSM_AUDIT_CLAIM_SEARCH_RESULTS: 'UPDATE_TCSM_AUDIT_CLAIM_SEARCH_RESULTS',
    UPDATE_TCSM_AUDIT_CLAIM_SORT_BY: 'UPDATE_TCSM_AUDIT_CLAIM_SORT_BY',
    UPDATE_TCSM_AUDIT_CLAIM_SORT_DIRECTION: 'UPDATE_TCSM_AUDIT_CLAIM_SORT_DIRECTION',
    UPDATE_TCSM_AUDIT_COUNT: 'UPDATE_TCSM_AUDIT_COUNT',
    UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET: 'UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET',
    UPDATE_TCSM_AUDIT_FACET_FILTER_TEXT: 'UPDATE_TCSM_AUDIT_FACET_FILTER_TEXT',
    UPDATE_TCSM_AUDIT_FILTERED_TERRITORIES: 'UPDATE_TCSM_AUDIT_FILTERED_TERRITORIES',
    UPDATE_TCSM_AUDIT_IS_INITIAL_LOAD: 'UPDATE_TCSM_AUDIT_IS_INITIAL_LOAD',
    UPDATE_TCSM_AUDIT_LEAD_ACCOUNT: 'UPDATE_TCSM_AUDIT_LEAD_ACCOUNT',
    UPDATE_TCSM_AUDIT_LIST: 'UPDATE_TCSM_AUDIT_LIST',
    UPDATE_TCSM_AUDIT_LIST_FILTER_BY: 'UPDATE_TCSM_AUDIT_LIST_FILTER_BY',
    UPDATE_TCSM_AUDIT_LIST_SORT_BY: 'UPDATE_TCSM_AUDIT_LIST_SORT_BY',
    UPDATE_TCSM_AUDIT_LIST_SORT_DIRECTION: 'UPDATE_TCSM_AUDIT_LIST_SORT_DIRECTION',
    UPDATE_TCSM_CLAIM_DEBIT_CLAIM_NUMBER: 'UPDATE_TCSM_CLAIM_DEBIT_CLAIM_NUMBER',
    UPDATE_TCSM_CLAIM_DEBIT_CONFIRMATION_MODAL_VISIBILITY: 'UPDATE_TCSM_CLAIM_DEBIT_CONFIRMATION_MODAL_VISIBILITY',
    UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM: 'UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM',
    UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM_COMMENTS: 'UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_ITEM_COMMENTS',
    UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_MODAL_VISIBILITY: 'UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_MODAL_VISIBILITY',
    UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_TYPE: 'UPDATE_TCSM_CLAIM_DEBIT_FULL_DEBIT_TYPE',
    UPDATE_TCSM_CLAIM_DEBIT_TYPE: 'UPDATE_TCSM_CLAIM_DEBIT_TYPE',
    UPDATE_TCSM_CLAIM_DEBIT_TYPES: 'UPDATE_TCSM_CLAIM_DEBIT_TYPES',
    UPDATE_TCSM_CLOSING_ACCOUNT: 'UPDATE_TCSM_CLOSING_ACCOUNT',
    UPDATE_TCSM_CLOSING_ACCOUNT_FILTER_BY: 'UPDATE_TCSM_CLOSING_ACCOUNT_FILTER_BY',
    UPDATE_TCSM_CLOSING_ACCOUNT_INDEX: 'UPDATE_TCSM_CLOSING_ACCOUNT_INDEX',
    UPDATE_TCSM_CLOSING_ACCOUNT_LENGTH: 'UPDATE_TCSM_CLOSING_ACCOUNT_LENGTH',
    UPDATE_TCSM_CLOSING_ACCOUNT_SORT_BY: 'UPDATE_TCSM_CLOSING_ACCOUNT_SORT_BY',
    UPDATE_TCSM_CLOSING_ACCOUNT_SORT_DIRECTION: 'UPDATE_TCSM_CLOSING_ACCOUNT_SORT_DIRECTION',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILE: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILE',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILTER_BY: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILTER_BY',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE_LENGTH: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE_LENGTH',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_BY: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_BY',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_DIRECTION: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_DIRECTION',
    UPDATE_TCSM_FACET_FILTER_TEXT: 'UPDATE_TCSM_FACET_FILTER_TEXT',
    UPDATE_TCSM_FILTERED_TERRITORIES: 'UPDATE_TCSM_FILTERED_TERRITORIES',
    UPDATE_TCSM_IS_INITIAL_LOAD: 'UPDATE_TCSM_IS_INITIAL_LOAD',
    UPDATE_TCSM_LABOR_RATE_CHANGES: 'UPDATE_TCSM_LABOR_RATE_CHANGES',
    UPDATE_TCSM_LABOR_RATE_CHANGES_FOR_ACCOUNT: 'UPDATE_TCSM_LABOR_RATE_CHANGES_FOR_ACCOUNT',
    UPDATE_TCSM_LABOR_RATE_COMMENTS_TO_DEALER: 'UPDATE_TCSM_LABOR_RATE_COMMENTS_TO_DEALER',
    UPDATE_TCSM_LABOR_RATE_FILTER_BY: 'UPDATE_TCSM_LABOR_RATE_FILTER_BY',
    UPDATE_TCSM_LABOR_RATE_INTERNAL_DEERE_COMMENTS: 'UPDATE_TCSM_LABOR_RATE_INTERNAL_DEERE_COMMENTS',
    UPDATE_TCSM_LABOR_RATE_OVERRIDE_EFFECTIVE_DATE: 'UPDATE_TCSM_LABOR_RATE_OVERRIDE_EFFECTIVE_DATE',
    UPDATE_TCSM_LABOR_RATE_QUERY: 'UPDATE_TCSM_LABOR_RATE_QUERY',
    UPDATE_TCSM_LABOR_RATE_REASON_FOR_OVERRIDE: 'UPDATE_TCSM_LABOR_RATE_REASON_FOR_OVERRIDE',
    UPDATE_TCSM_LABOR_RATE_SORT_BY: 'UPDATE_TCSM_LABOR_RATE_SORT_BY',
    UPDATE_TCSM_LABOR_RATE_SORT_DIRECTION: 'UPDATE_TCSM_LABOR_RATE_SORT_DIRECTION',
    UPDATE_TCSM_LABOR_RATE_STATUS: 'UPDATE_TCSM_LABOR_RATE_STATUS',
    UPDATE_TCSM_MACHINE_STATUS_COMMENTS_TO_DEALER: 'UPDATE_TCSM_MACHINE_STATUS_COMMENTS_TO_DEALER',
    UPDATE_TCSM_MACHINE_STATUS_FILTER_BY: 'UPDATE_TCSM_MACHINE_STATUS_FILTER_BY',
    UPDATE_TCSM_MACHINE_STATUS_INTERNAL_DEERE_COMMENTS: 'UPDATE_TCSM_MACHINE_STATUS_INTERNAL_DEERE_COMMENTS',
    UPDATE_TCSM_MACHINE_STATUS_ITEM_TO_UPDATE: 'UPDATE_TCSM_MACHINE_STATUS_ITEM_TO_UPDATE',
    UPDATE_TCSM_MACHINE_STATUS_QUERY: 'UPDATE_TCSM_MACHINE_STATUS_QUERY',
    UPDATE_TCSM_MACHINE_STATUS_SORT_BY: 'UPDATE_TCSM_MACHINE_STATUS_SORT_BY',
    UPDATE_TCSM_MACHINE_STATUS_SORT_DIRECTION: 'UPDATE_TCSM_MACHINE_STATUS_SORT_DIRECTION',
    UPDATE_TCSM_MACHINE_STATUS_UPDATES: 'UPDATE_TCSM_MACHINE_STATUS_UPDATES',
    UPDATE_TCSM_MACHINE_STATUS_UPDATES_LIST: 'UPDATE_TCSM_MACHINE_STATUS_UPDATES_LIST',
    UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE: 'UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE',
    UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE_COLLECTION: 'UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE_COLLECTION',
    UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_VALUE: 'UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_VALUE',
    UPDATE_TCSM_PARTIAL_DEBIT_COMMENTS: 'UPDATE_TCSM_PARTIAL_DEBIT_COMMENTS',
    UPDATE_TCSM_PARTIAL_DEBIT_COMPANY_CONTRIBUTION: 'UPDATE_TCSM_PARTIAL_DEBIT_COMPANY_CONTRIBUTION',
    UPDATE_TCSM_PARTIAL_DEBIT_CONFIRMATION_MODAL_VISIBILITY: 'UPDATE_TCSM_PARTIAL_DEBIT_CONFIRMATION_MODAL_VISIBILITY',
    UPDATE_TCSM_PARTIAL_DEBIT_DATA: 'UPDATE_TCSM_PARTIAL_DEBIT_DATA',
    UPDATE_TCSM_PARTIAL_DEBIT_MODAL_VISIBILITY: 'UPDATE_TCSM_PARTIAL_DEBIT_MODAL_VISIBILITY',
    UPDATE_TCSM_PARTIAL_DEBIT_TYPE: 'UPDATE_TCSM_PARTIAL_DEBIT_TYPE',
    UPDATE_TCSM_PERCENTAGE_DEBIT_COMMENTS: 'UPDATE_TCSM_PERCENTAGE_DEBIT_COMMENTS',
    UPDATE_TCSM_PERCENTAGE_DEBIT_CONFIRMATION_MODAL_VISIBILITY: 'UPDATE_TCSM_PERCENTAGE_DEBIT_CONFIRMATION_MODAL_VISIBILITY',
    UPDATE_TCSM_PERCENTAGE_DEBIT_DATA: 'UPDATE_TCSM_PERCENTAGE_DEBIT_DATA',
    UPDATE_TCSM_PERCENTAGE_DEBIT_MODAL_VISIBILITY: 'UPDATE_TCSM_PERCENTAGE_DEBIT_MODAL_VISIBILITY',
    UPDATE_TCSM_PERCENTAGE_DEBIT_TYPE: 'UPDATE_TCSM_PERCENTAGE_DEBIT_TYPE',
    UPDATE_TCSM_PERCENTAGE_DEBIT_VALUE: 'UPDATE_TCSM_PERCENTAGE_DEBIT_VALUE',
    UPDATE_TCSM_PIP_CODE_REQUESTS: 'UPDATE_TCSM_PIP_CODE_REQUESTS',
    UPDATE_TCSM_PIP_CODE_REQUESTS_FILTER_BY: 'UPDATE_TCSM_PIP_CODE_REQUESTS_FILTER_BY',
    UPDATE_TCSM_PIP_CODE_REQUESTS_LIST: 'UPDATE_TCSM_PIP_CODE_REQUESTS_LIST',
    UPDATE_TCSM_PIP_CODE_REQUESTS_QUERY: 'UPDATE_TCSM_PIP_CODE_REQUESTS_QUERY',
    UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_BY: 'UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_BY',
    UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_DIRECTION: 'UPDATE_TCSM_PIP_CODE_REQUESTS_SORT_DIRECTION',
    UPDATE_TCSM_PIP_CODE_REQUEST_ITEM_TO_UPDATE: 'UPDATE_TCSM_PIP_CODE_REQUEST_ITEM_TO_UPDATE',
    UPDATE_TCSM_PIP_CODE_REQUEST_TCSM_COMMENTS: 'UPDATE_TCSM_PIP_CODE_REQUEST_TCSM_COMMENTS',
    UPDATE_TCSM_PREPARE_AUDIT_AUDIT: 'UPDATE_TCSM_PREPARE_AUDIT_AUDIT',
    UPDATE_TCSM_PREPARE_AUDIT_FACET_DATE_ISSUED: 'UPDATE_TCSM_PREPARE_AUDIT_FACET_DATE_ISSUED',
    UPDATE_TCSM_PREPARE_AUDIT_FACET_REIMBURSEMENT_AMOUNT: 'UPDATE_TCSM_PREPARE_AUDIT_FACET_REIMBURSEMENT_AMOUNT',
    UPDATE_TCSM_PREPARE_AUDIT_IS_AUDIT_LOADED: 'UPDATE_TCSM_PREPARE_AUDIT_IS_AUDIT_LOADED',
    UPDATE_TCSM_PREPARE_AUDIT_SYSTEM_SELECTED_CLAIMS_MODAL_VISIBILITY: 'UPDATE_TCSM_PREPARE_AUDIT_SYSTEM_SELECTED_CLAIMS_MODAL_VISIBILITY',
    UPDATE_TCSM_PREPARE_AUDIT_USER_SELECTED_CLAIMS_MINIMUM: 'UPDATE_TCSM_PREPARE_AUDIT_USER_SELECTED_CLAIMS_MINIMUM',
    UPDATE_TCSM_RECORD_AUDIT_ACTUAL_AUDIT_DATE: 'UPDATE_TCSM_RECORD_AUDIT_ACTUAL_AUDIT_DATE',
    UPDATE_TCSM_RECORD_AUDIT_CONFIRMATION_MODAL_VISIBILITY: 'UPDATE_TCSM_RECORD_AUDIT_CONFIRMATION_MODAL_VISIBILITY',
    UPDATE_TCSM_RECORD_AUDIT_DATA: 'UPDATE_TCSM_RECORD_AUDIT_DATA',
    UPDATE_TCSM_RECORD_AUDIT_FILE: 'UPDATE_TCSM_RECORD_AUDIT_FILE',
    UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM: 'UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM',
    UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM_COMMENTS: 'UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_ITEM_COMMENTS',
    UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_MODAL_VISIBILITY: 'UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_MODAL_VISIBILITY',
    UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_TYPE: 'UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_TYPE',
    UPDATE_TCSM_RECORD_AUDIT_MODAL_VISIBILITY: 'UPDATE_TCSM_RECORD_AUDIT_MODAL_VISIBILITY',
    UPDATE_TCSM_RECORD_AUDIT_RESULTS: 'UPDATE_TCSM_RECORD_AUDIT_RESULTS',
    UPDATE_TCSM_SEARCH_BY: 'UPDATE_TCSM_SEARCH_BY',
    UPDATE_TCSM_SEARCH_QUERY_STRING: 'UPDATE_TCSM_SEARCH_QUERY_STRING',
    UPDATE_TCSM_SELECTED_DEALER_ACCOUNTS: 'UPDATE_TCSM_SELECTED_DEALER_ACCOUNTS',
    UPDATE_TCSM_SPA_CLAIMS: 'UPDATE_TCSM_SPA_CLAIMS',
    UPDATE_TCSM_SPA_CLAIMS_FILTER_BY: 'UPDATE_TCSM_SPA_CLAIMS_FILTER_BY',
    UPDATE_TCSM_SPA_CLAIMS_QUERY: 'UPDATE_TCSM_SPA_CLAIMS_QUERY',
    UPDATE_TCSM_SPA_CLAIMS_SORT_BY: 'UPDATE_TCSM_SPA_CLAIMS_SORT_BY',
    UPDATE_TCSM_SPA_CLAIMS_SORT_DIRECTION: 'UPDATE_TCSM_SPA_CLAIMS_SORT_DIRECTION',
    UPDATE_TCSM_SPA_CLAIM_COMMENTS_TO_DEALER: 'UPDATE_TCSM_SPA_CLAIM_COMMENTS_TO_DEALER',
    UPDATE_TCSM_SPA_CLAIM_CONTRIBUTION: 'UPDATE_TCSM_SPA_CLAIM_CONTRIBUTION',
    UPDATE_TCSM_SPA_CLAIM_DETAILS: 'UPDATE_TCSM_SPA_CLAIM_DETAILS',
    UPDATE_TCSM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS: 'UPDATE_TCSM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS',
    UPDATE_TCSM_SPA_CLAIM_SELECTED_CONTRIBUTION: 'UPDATE_TCSM_SPA_CLAIM_SELECTED_CONTRIBUTION',
    UPDATE_TCSM_SPA_CLAIM_STATUS: 'UPDATE_TCSM_SPA_CLAIM_STATUS',
    UPDATE_TCSM_SPA_TYPE: 'UPDATE_TCSM_SPA_TYPE',
    UPDATE_TCSM_SPA_TYPES: 'UPDATE_TCSM_SPA_TYPES',
    UPDATE_TCSM_WIP_FACETS: 'UPDATE_TCSM_WIP_FACETS',
    UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS: 'UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS',
    UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS_LIST: 'UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS_LIST',
    UPDATE_TCSM_WIP_TCSM_SETTINGS: 'UPDATE_TCSM_WIP_TCSM_SETTINGS',
    UPDATE_USER_TERRITORIES: 'UPDATE_USER_TERRITORIES'
});



// WEBPACK FOOTER //
// ./src/tcsm/actions-list.js